export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Analyzing).b12d3c22.jpg";